var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"closeButton",on:{"click":_vm.cancel}},[_c('i',{staticClass:"fas fa-times"})])}
var staticRenderFns = []

export { render, staticRenderFns }